

export const FETCH_VEHICLE_DEALERSHIPVEHICLEDEAL_LIST = {
    START: 'FETCH_VEHICLE_DEALERSHIPVEHICLEDEAL_LIST_START',
    SUCCESS: 'FETCH_VEHICLE_DEALERSHIPVEHICLEDEAL_LIST_SUCCESS',
    ERROR: 'FETCH_VEHICLE_DEALERSHIPVEHICLEDEAL_LIST_ERROR',
  };
  export const TOAST = {
    RESET: 'RESET_TOAST',
  };
  export const FETCH_VEHICLE_DEALERSHIPVEHICLEDEAL_INIT="FETCH_VEHICLE_DEALERSHIPVEHICLEDEAL_INIT"
  export const SET_DELETE_CONFIRMATION_POPUP_VISIBILITY =
  'SET_DELETE_CONFIRMATION_POPUP_VISIBILITY';


  
export const INIT_CREATE_VEHICLE_DEALERSHIPVEHICLEDEAL_SCREEN =
'INIT_CREATE_VEHICLE_DEALERSHIPVEHICLEDEAL_SCREEN';

export const CREATE_VEHICLE_DEALERSHIPVEHICLEDEAL = {
START: 'CREATE_VEHICLE_DEALERSHIPVEHICLEDEAL_START',
SUCCESS: 'CREATE_VEHICLE_DEALERSHIPVEHICLEDEAL_SUCCESS',
ERROR: 'CREATE_VEHICLE_DEALERSHIPVEHICLEDEAL_ERROR',
};

export const EDIT_VEHICLE_DEALERSHIPVEHICLEDEAL = {
START: 'EDIT_VEHICLE_DEALERSHIPVEHICLEDEAL_START',
SUCCESS: 'EDIT_VEHICLE_DEALERSHIPVEHICLEDEAL_SUCCESS',
ERROR: 'EDIT_VEHICLE_DEALERSHIPVEHICLEDEAL_ERROR',
};

export const FETCH_VEHICLE_DEALERSHIPVEHICLEDEAL_DETAIL = {
  START: 'FETCH_VEHICLE_DEALERSHIPVEHICLEDEAL_DETAIL_START',
  SUCCESS: 'FETCH_VEHICLE_DEALERSHIPVEHICLEDEAL_DETAIL_SUCCESS',
  ERROR: 'FETCH_VEHICLE_DEALERSHIPVEHICLEDEAL_DETAIL_ERROR',
};
export const EXPORT_VEHICLE_DEALERSHIPVEHICLEDEAL = {
  START: 'EXPORT_VEHICLE_DEALERSHIPVEHICLEDEAL_START',
  SUCCESS: 'EXPORT_VEHICLE_DEALERSHIPVEHICLEDEAL_SUCCESS',
  ERROR: 'EXPORT_VEHICLE_DEALERSHIPVEHICLEDEAL_ERROR',
};
export const VEHICLE_OPERATIONDD = {
  START: 'VEHICLE_OPERATIONDD_START',
  SUCCESS: 'VEHICLE_OPERATIONDD_SUCCESS',
  ERROR: 'VEHICLE_OPERATIONDD_ERROR',
};